let portalFeaturesCache = { email: null, features: null };
let rbacCache = { email: null, permissions: null };

export function getPortalFeaturesCache(email) {
  if (!email || portalFeaturesCache.email !== email) {
    return null;
  }

  return portalFeaturesCache.features;
}

export function setPortalFeaturesCache(email, features) {
  portalFeaturesCache = { email, features };
}

export function getRBACCache(email) {
  if (!email || rbacCache.email !== email) {
    return null;
  }

  return rbacCache.permissions;
}

export function setRBACCache(email, permissions) {
  rbacCache = { email, permissions };
}

export function clearAuthCaches() {
  portalFeaturesCache = { email: null, features: null };
  rbacCache = { email: null, permissions: null };
}

export function notifyAuthContextChanged() {
  clearAuthCaches();
  window.dispatchEvent(new Event("portal-features-changed"));
  window.dispatchEvent(new Event("rbac-changed"));
}
